
	import { Component, Vue } from 'vue-property-decorator';

	@Component({
		components: {}
	})
	export default class ViewportWrapper extends Vue {
		protected get computedStyle(): Partial<CSSStyleDeclaration> {
			return {
				margin: 'auto',
				paddingRight: '5px',
				paddingLeft: '5px',
				minWidth: this.largeScreen ? '1280px' : '840px',
				maxWidth: this.largeScreen ? '80%' : '1280px'
			};
		}

		protected largeScreen = true;

		protected created(): void {
			//to support legacy @media query 100em
			const mediaQuery = window.matchMedia('(min-width: 100em)');
			// @ts-ignore
			mediaQuery.addEventListener('change', this.onResize);

			this.onResize(mediaQuery);
		}

		protected onResize(e: MediaQueryList): void {
			this.largeScreen = e.matches;
		}
	}
